<template>
  <div class="">
    <div class="bootstrap-wrapper">
      <div class="container">
        <!--header start-->
        <div class="row item-center-in-flex-row">

          <!--Logo -->
          <div class="col-12 text-align-center margin-bottom-10 order-1" v-if="!coBrandingLogoSrc">
            <weex-image :src="ezCredLogoSrc" v-on:click="openEzCredWebsite"
              class="ez-logo cp"
            ></weex-image>
          </div>
          <div class="col-6 margin-bottom-10 order-1"  v-if="coBrandingLogoSrc">
            <weex-image :src="ezCredLogoSrc" v-on:click="openEzCredWebsite"
              class="ez-logo cp"
            ></weex-image>
          </div>
          <div v-if="coBrandingLogoSrc" class="col-6 margin-bottom-10 order-2 text-align-end">
            <weex-image :src="coBrandingLogoSrc"
              class="cobranding-logo"
            ></weex-image>
          </div>
          <!--Logo end -->

        </div>
        <!--header ends-->

        <!-- About co branding -->
        <div class="row margin-top-30 item-row-alignment-justify-content-center">
            <div class="col-12 col-md-5 text-align-center">
                <h1>{{header.title}}</h1>
            </div>
        </div>
        <div class="row margin-top-30 item-row-alignment-justify-content-center">
            <div class="col-12 col-md-6 text-align-center">
                 <weex-text class="text-color-gray margin-bottom-10">
                    <span class="font-size-base">
                        {{header.text}}
                    </span>
                </weex-text>  
            </div>
        </div>
        <div class="row margin-top-30 item-row-alignment-justify-content-center">
            <div class="col-12 col-md-6 text-align-center">
                <wxc-button
                  :text="applyButtonText"
                  size="normal"
                  class="apply-btn"
                  type="blue"
                  @wxcButtonClicked="onApplyEMIClick"
                ></wxc-button> 
            </div>
        </div>
        <!--About co branding end -->

        <!--Benifites -->
        <div class="row margin-top-30">
            <div class="col-12 col-md-6 margin-top-30">
                <weex-text class="text-color-gray margin-bottom-10">
                    <div class="font-size-xxl margin-bottom-10">
                       {{benifitTitle}}
                    </div>
                </weex-text> 
                <div class="input_container margin-top-20">
                    <div v-for="(benifit, index) in benifitPoints" :key="index">
                    <weex-text class="text-color-gray margin-bottom-10">
                        <div class="circle"> &#10003; </div>
                        <span class="font-size-base">{{ benifit }}</span>
                    </weex-text>  
                    </div>
                </div> 
                <weex-text
                  v-if="showRetailerOnBoardingExtraDetails"
                  class="margin-top-10 font-size-sm-base text-color-black"
                  v-html="partnerMoreDetails"
                ></weex-text>
            </div>
            <div class="hidden-md-down col-md-6 text-align-center align-self-center">
               <img src="../../../../src/assets/benifits.jpg"
                class="beifits-img"
                />
            </div>
        </div>
        <!--Benifites end -->


        <!--Process  -->
        <div class="row margin-top-30">
            <div class="hidden-md-down col-md-6 margin-top-30 align-self-center">
               <img src="../../../../src/assets/process.jpg"
                class="process-img"
                />
            </div>
            <div class="col-12 col-md-6 margin-top-30">
                <weex-text class="text-color-gray margin-bottom-20">
                    <div class="font-size-xxl margin-bottom-10">
                       {{processTitle}}
                    </div> 
                </weex-text>  
                <div class="input_container margin-top-20">
                    <div class="row">
                        <div class="col-12 col-md-6 margin-bottom-10" v-for="(step, index) in processSteps" :key="index">
                        <img :src="getImgUrl(step.retailerProcessImageName)" class="process-icon"/>
                        <weex-text class="text-color-gray margin-bottom-10">
                            <div class="font-size-sm"> <strong> {{index+1}}. {{ step.retailerProcessTitle }}</strong></div>
                            <div class="font-size-sm margin-left-5">{{ step.retailerProcessDescription }}</div>
                        </weex-text>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Process end -->
      </div>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../../weex-ui/packages/wxc-button/index";
import { ImageResourcesUtil } from "../../../utils/ImageResourcesUtil";
import {Constants} from "../../Constants";
import ActivityNavigator, {
  Activities,
} from "../../../utils/ActivityNavigator";
import ToolBar from "../../layout/ToolBar";

export default {
  name: "LandingPageDekstopView",
  components: { ToolBar, WxcButton },
  data: () => ({}),
  props: {
    ezCredLogoSrc: {
      type: String,
      required: true
    },
    coBrandingLogoSrc: {
      type: String,
      required: false
    },
    benifitPoints: {
      type: Array,
      required: true
    },
    processSteps: {
      type: Array,
      required: true
    },
    header: {
      type: Object,
      required: true
    },
    benifitTitle : {
      type: String,
      required: true
    },
    processTitle : {
      type: String,
      required: true
    },
    applyButtonText : {
      type: String,
      required: true
    },
    showRetailerOnBoardingExtraDetails : {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    onApplyEMIClick() {
      this.$emit("onApplyEMIClick");
    },

    openEzCredWebsite() {
      window.open(Constants.EZCRED_WEBSITE_URL);
    },

    getImgUrl(img) {
      try{
        var images = require.context('../../../../src/assets/', false, /\.png$/)
        return images('./' + img + ".png")
      }catch{
        return images('./HappyMan.png');
      }
    }
  },

  beforeCreate() {
    document.body.className = 'reset-body-style';
  },

  computed: {
    partnerMoreDetails() {
      return `<html>Partner with EzCred for more details please <a target="_blank" href="https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/onboarding.pdf">click here</a>.</html>`;
    },
  },
};
</script>

<style
  scoped
  src="../../../assets/style/base.css"></style>

<style
  scoped
  src="../../../assets/style/bootstarp-grid.css"></style>

<style scoped>

.ez-logo {
    height: 1.5625rem;
    width: 8.75rem;
}

.apply-btn{
    border-radius: 4px;
    height: 40px;
}

.cobranding-logo {
    width: 120px;
}

.beifits-img{
    max-width: 150px;
}

.process-img{
    max-width: 250px;
}

.process-icon{
  height: 30px;
}

.dv {
  height: calc(100vh) !important;
  width: calc(100vw) !important;
  background: #fff;
}

.circle {
  width: 15px;
  height: 15px;
  line-height: 15px;
  border-radius: 15px;
  color: #fff;
  text-align: center;
  background: #4dad5a;
  margin-right: 5px;
  display: inline-block;
}
</style>
